import "./App.css";
import { Route, Routes } from "react-router-dom";
import "./styles/Responsive.css";
import "./styles/Style.css";
import "./styles/Common.css";
import Home from "./pages/home/Home";
import Navbar from "./components/navbar/Navbar.component";
import Footer from "./components/footer/Footer.component";
import ConfigContextProvider, { ConfigContext } from "./context/config";
import Login from "./components/login/Login.component";
import Team from "./components/Team/Team.component";
import About from "./pages/About/About";
import NotFound from "./pages/NotFound/NotFound";
import SelectTweet from "./pages/SelectTweet/SelectTweet";
import Blog from "./pages/Blog/Blog.page";
import BlogDetails from "./pages/Blog/BlogDetails.page";
import Faq from "./pages/Faq/Faq.page";
import { FaqData, FaqData2 } from "./pages/Faq/Faq.data";
import Signup from "./pages/Signup/Signup.page";
import CheckProfile from "./pages/CheckProfile/CheckProfile.page";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  desoLoginSuccess,
  facebookUserData,
  onAuthChange,
  twitterSignOut,
  twitterUserData,
  wordPressStart,
} from "./reducers/auth/action";
import DiamondLoginTwitter from "./pages/home/DiamondLoginTwitter";
import Dashboard from "./pages/Dashboard/Dashboard.Page";
import SyncContent from "./components/login/SyncContent";
import { detectIncognito } from "detectincognitojs";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { RealTimeSync } from "./pages/RealTimeSync/RealTimeSync.page";
const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(onAuthChange());
    dispatch(twitterUserData());
    dispatch(wordPressStart());

    // logout existing user
    if (localStorage.getItem("desoCred")) {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(desoLoginSuccess(null));
      dispatch(twitterSignOut());
    }
  }, []);

  const pn = window.location.pathname;

  detectIncognito().then((result) => {
    if (result?.isPrivate) {
      if (localStorage.getItem("show") !== "show_done") {
        localStorage.setItem("show", "show_done");
        Swal.fire({
          icon: "",
          title: `<p class="text-[24px] text-[#000000] font-bold">Please turn off incognito mode</p>`,
          text: "We do not have the access required to sync your content in incognito mode. Please turn off private browsing to use our service.",
          confirmButtonText: "ok!",
        }).then(() => {});
      }
    }
  });

  return (
    <div>
      <Helmet>
        <title>
          Expand Your Brand In Web 3.0 For Free And Earn More - Setu
        </title>
        <meta
          name="description"
          content="Bridge the gap between Web 2.0 and Web 3.0 with Setu. Move your content to decentralised social media. Earn more, own your content, and expand your brand."
        />
      </Helmet>
      <ConfigContextProvider>
        {pn !== "/login_twitter_diamond" && <Navbar />}
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:id" element={<BlogDetails />} />
          <Route path="/:id/sync_your_content" element={<SyncContent />} />
          <Route path="/:id/real_time_sync" element={<RealTimeSync />} />
          <Route path="/:id/past_all_contents" element={<SelectTweet />} />
          <Route path="/our_team" element={<Team />} />
          <Route path="/profile" element={<Signup />} />
          <Route path="/check_profile" element={<CheckProfile />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route
            path="/login_twitter_diamond"
            element={<DiamondLoginTwitter />}
          />

          <Route
            path="/faqs"
            element={
              <Faq title={"Still have questions?"} t1={FaqData} t2={FaqData2} />
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {pn !== "/login_twitter_diamond" && <Footer />}
      </ConfigContextProvider>
    </div>
  );
};

export default App;
